import entries from 'object.entries'

if (!Object.entries)
  entries.shim()



// WEBPACK FOOTER //
// ./src/lib/polyfills/object.entries.js